// Trạng thái thực hiện
export default {
    NoAction: 0, // 'Không xử lý'
    Inward: 1, // 'Nhập kho'
    Outward: 2 // 'Xuất kho'
};